import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const InviteReminderBanner = ({
  invites,
  onClose: handleClose,
  onButtonClick: handleButtonClick
}) => {
  const {
    trackSectionView,
    trackUserInteraction
  } = useTracker();
  useEffect(() => {
    trackSectionView('banner', 'invite reminder banner');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    "data-test-id": "invite-reminder-banner",
    onClose: () => {
      handleClose();
      trackUserInteraction('click invite reminder banner close button');
    },
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.inviteReminderBanner.heading",
      options: {
        count: invites.length
      }
    }),
    type: "info",
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "review-invites-btn",
      onClick: () => {
        handleButtonClick();
        trackUserInteraction('click review invites button');
      },
      size: "extra-small",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.inviteReminderBanner.reviewInvites"
      })
    })
  });
};
export default InviteReminderBanner;